import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
import { Close } from '@material-ui/icons'

import { SearchContainer } from './components'
import styles from './styles'
import { StoreValue } from 'store'
import { ECompanyActionTypes } from 'models'

const useStyles = makeStyles(styles)

const LocationsView: React.FunctionComponent<any> = memo(props => {
	const {
		headquartersOfficeType = false,
		headquarters,
		offices,
		storeDispatch,
	} = props	
	const { t } = useTranslation()
	const classes = useStyles()
	let selectedLocations: any = headquartersOfficeType
		? headquarters.selected
		: offices.selected

	const deselect: any = (location: any) => () => {
		if (headquartersOfficeType) {
			storeDispatch({
				type: ECompanyActionTypes.setDeselectHeadquarters,
				headquarters: { location },
			})
		} else {
			storeDispatch({
				type: ECompanyActionTypes.setDeselectOffices,
				offices: { location },
			})
		}
	}

	return (
		<div className={classes.locationsRoot}>
			<div className={classes.selectedLoc}>
				{selectedLocations.map((item: any) => (
					<Chip
						key={item.id}
						variant="outlined"
						className={classes.chip}
						label={item.name}
						clickable={true}
						size={'small'}
						onDelete={deselect(item)}
						deleteIcon={<Close />}
					/>
				))}
			</div>
			<SearchContainer
				headquartersOfficeType={headquartersOfficeType}
				placeholder={t('Type a location...')}
			/>
		</div>
	)
})

const Locations = (props: any) => (
	<StoreValue
		keys={[
			'company.offices|offices',
			'company.headquarters|headquarters',
			'storeDispatch',
		]}
	>
		<LocationsView {...props} />
	</StoreValue>
)

export default Locations
